module.exports = "<igo-list [navigation]=\"false\" [selection]=\"false\">\r\n  <ng-template ngFor let-layer [ngForOf]=\"layers\">\r\n    <igo-layer-item *ngIf=\"!(excludeBaseLayers && layer.baseLayer)\"\r\n        igoListItem\r\n        [color]=\"color\"\r\n        [layer]=\"layer\"\r\n        [ogcFilterInLayerItem]=\"ogcFilterInLayerItem\"\r\n        [toggleLegendOnVisibilityChange]=\"toggleLegendOnVisibilityChange\">\r\n    </igo-layer-item>\r\n  </ng-template>\r\n\r\n  <ng-content></ng-content>\r\n</igo-list>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/layer/layer-list/layer-list.component.html
// module id = 1048
// module chunks = 0